export function flatten(collection){
  return collection.reduce(function(prev, inner) {
    inner = Array.isArray(inner) ? inner : [inner]
    const  multiLevel = (inner).some(Array.isArray);
    return prev.concat(multiLevel ? flatten(inner) : inner);
  },[]);
}

export function compact(array){
  return array.filter(x => x)
}

export function sortByPosition(items){
  return items.sort((a, b) => {
    let aPosition = a.attributes.position
    let bPosition = b.attributes.position
    if(aPosition < bPosition) return -1
    if(bPosition < aPosition) return 1
    return 0
  })
}

export function sortByName(items) {
  return items.sort((a, b) => {
    let aName = a.attributes.name.toLowerCase()
    let bName = b.attributes.name.toLowerCase()

    if (aName < bName) return -1
    if (aName > bName) return 1
    return 0
  })
}

export function partition(predicateFn) {
  return collection => collection.reduce((accum, item) => {
    predicateFn(item) ? accum[0].push(item) : accum[1].push(item)
    return accum
  }, [[],[]])
}

export function assignIndexOf(collection) {
  return item => collection.includes(item) ? ({
    index: collection.indexOf(item),
    ...item
  }) : item
}

export function pipe(...fns){
  return args => {
    return fns.reduce((accum, fn) => fn(accum), args)
  }
}